export default __webpack_public_path__ + "static/media/2.d7291ee3.png";